import SettingBox from 'components/SettingBox'
import NotFooterLayout from 'layouts/NotFooterLayout'
import React from 'react'

const SettingBoxPage = () => {
  return (
    <NotFooterLayout namePage="ตั้งค่ากล่อง">
        <div className="layout-content">
           <SettingBox />
        </div>
    </NotFooterLayout>
  )
}

export default SettingBoxPage